/**
 * R7.2.2F4C — canonical Customer cart quantity semantics.
 * SKU line qty ≠ total cart qty. CTA + nav badge must share total.
 */
export type CartLineQty = { id: string; qty: number };

/** Sum of all line quantities — single source for badge + "У кошику: N · Перейти". */
export function cartTotalQuantity(cart: readonly CartLineQty[]): number {
  let total = 0;
  for (const line of cart) {
    const q = Number(line.qty);
    if (Number.isFinite(q) && q > 0) total += Math.floor(q);
  }
  return total;
}

/** Quantity of one SKU in cart (stepper / line control). */
export function cartSkuQuantity(cart: readonly CartLineQty[], productId: string): number {
  const line = cart.find((i) => i.id === productId);
  const q = Number(line?.qty ?? 0);
  return Number.isFinite(q) && q > 0 ? Math.floor(q) : 0;
}
